// extracted by mini-css-extract-plugin
module.exports = {"sortableItem":"OrderAnswer_sortableItem__ntjy5","notice":"OrderAnswer_notice__VaG4Z"};